// store/timezoneStore.ts
import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export const COMMON_TIMEZONES = [
  {
    value: 'UTC',
    label: 'UTC',
    offset: 'UTC+0',
    locale: 'en-GB',
  },
  {
    value: 'Europe/Bucharest',
    label: 'Bucharest (EET/EEST)',
    offset: 'UTC+2/+3',
    locale: 'ro-RO',
  },
  {
    value: 'Australia/Sydney',
    label: 'Sydney (AEST/AEDT)',
    offset: 'UTC+10/+11',
    locale: 'en-AU',
  },
  {
    value: 'Australia/Adelaide',
    label: 'Adelaide (ACST/ACDT)',
    offset: 'UTC+9:30/+10:30',
    locale: 'en-AU',
  },
  {
    value: 'Australia/Perth',
    label: 'Perth (AWST)',
    offset: 'UTC+8',
    locale: 'en-AU',
  },
];

export const TIMEZONE_TO_LOCALE: Record<string, string> = {
  UTC: 'en-GB',
  'Europe/Bucharest': 'ro-RO',
  'Europe/Kiev': 'uk-UA',
  'Australia/Sydney': 'en-AU',
  'Australia/Adelaide': 'en-AU',
  'Australia/Perth': 'en-AU',
};

interface TimezoneState {
  timezone: string;
  locale: string;
  setTimezone: (timezone: string) => void;
  setLocale: (locale: string) => void;
  getLocaleForTimezone: (timezone: string) => string;
}

export const useTimezoneStore = create<TimezoneState>()(
  persist(
    (set) => {
      const defaultTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      const defaultLocale =
        TIMEZONE_TO_LOCALE[defaultTimezone] || navigator.language || 'en-US';

      return {
        timezone: defaultTimezone,
        locale: defaultLocale,
        setTimezone: (timezone: string) => {
          const locale =
            TIMEZONE_TO_LOCALE[timezone] || navigator.language || 'en-US';
          set({ timezone, locale });
        },
        setLocale: (locale: string) => set({ locale }),
        getLocaleForTimezone: (timezone: string) => {
          return TIMEZONE_TO_LOCALE[timezone] || navigator.language || 'en-US';
        },
      };
    },
    {
      name: 'timezone-storage',
    }
  )
);
